module.exports = __webpack_public_path__ + "static/media/header-mobile.25ed4ffc.png";